import React, { useCallback, useMemo } from 'react'
import { BoxProps, Button } from 'rebass'
import SBox from 'components/opinionless/SBox'

import MenuSvg from '@svgs/menu.svg'
import ArrowSvg from '@svgs/arrow.svg'
import { SPageType } from './opinionless/SPage'

import SIcon from './opinionless/SIcon'

import SLink from './opinionless/SLink'
import { useRouter } from 'next/router'
import LanguageSwitcher from './LanguageSwitcher'
import { SStyled, useSTheme } from 'styles/theme'
import { defaultMargin } from './BaseComponents/constants'

interface Props extends BoxProps {
    pageType: SPageType
    onClickHamburger: () => void
}

const menuIconSize = 16

const StyledLanguageSwitcher = SStyled(LanguageSwitcher)`
    position: static;
    right: 0px;
    border: 1px solid white;
`

const MobileTopBar: React.FC<Props> = (props: Props) => {
    const { pageType, onClickHamburger, sx = {} } = props

    const router = useRouter()
    const theme = useSTheme()

    const isLongBeachApplyFlow = useMemo(() => {
        return window.PROGRAM.name.toLowerCase().includes('long') && window.PROGRAM.name.toLowerCase().includes('beach')
    }, [window])

    const isChicagoFLow = useMemo(() => {
        return window.PROGRAM.name.toLowerCase().includes('chicago')
    }, [window])

    const onClickBack = useCallback(() => {
        router.push(`${window.POTENTIAL_USER?.program?.urlFragment || window.PROGRAM.urlFragment}/`)
    }, [router])

    const renderLeftButton = () => {
        if (pageType === SPageType.Authed) {
            return (
                <Button onClick={onClickHamburger} size={menuIconSize}>
                    <SIcon icon={MenuSvg} size={menuIconSize} tintColor="white" />
                </Button>
            )
        } else if (pageType === SPageType.UnauthedHelp) {
            return (
                <Button onClick={onClickBack} size={menuIconSize} mb={2}>
                    <SIcon
                        icon={ArrowSvg}
                        size={menuIconSize}
                        tintColor="white"
                        sx={{
                            transform: 'rotate(180deg)',
                        }}
                    />
                </Button>
            )
        } else {
            return null
        }
    }

    const renderRightSpacer = () => {
        if (pageType === SPageType.Authed || pageType === SPageType.UnauthedHelp) {
            return <SBox flex={`0 0 ${menuIconSize}px`} minWidth={'55px'} />
        } else {
            return null
        }
    }

    const getLogoWidth = () => {
        return isLongBeachApplyFlow
            ? '104px'
            : isChicagoFLow
            ? 'auto'
            : window?.ORGANIZATION.version === 2
            ? 'auto'
            : '175px'
    }

    const getLogoHeight = () => {
        return isLongBeachApplyFlow ? defaultMargin : isChicagoFLow ? '70px' : '120%'
    }

    return (
        <SBox
            sx={{
                height: isLongBeachApplyFlow ? 64 : 100,
                bg: theme.colors.secondaryColor,
                position: 'relative',
                width: '100%',
                flexDirection: 'row',
                display: ['flex', 'none', 'none'],
                px: isLongBeachApplyFlow ? defaultMargin : 3,
                py: isLongBeachApplyFlow ? '19px' : 5,
                alignItems: 'flex-start',
                justifyContent: 'space-between',
            }}
        >
            {renderLeftButton()}
            <SLink
                href={`${window.POTENTIAL_USER?.program?.urlFragment || window.PROGRAM.urlFragment}/`}
                style={{ height: 26 }}
            >
                <img src={`${theme.logos.mobileLogo}`} width={getLogoWidth()} height={getLogoHeight()} alt={'logo'} />
            </SLink>

            {renderRightSpacer()}
            {window && !window.location.href.includes('chicago') && (
                <StyledLanguageSwitcher switcherId={'mobile'} isAuthed={true} defaultLanguage={'en'} />
            )}
        </SBox>
    )
}

export default MobileTopBar
